import { render, staticRenderFns } from "./WireTransferForm.vue?vue&type=template&id=5fd50d77&"
import script from "./WireTransferForm.vue?vue&type=script&lang=js&"
export * from "./WireTransferForm.vue?vue&type=script&lang=js&"
import style0 from "./WireTransferForm.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports